import { BadgeWithTooltip } from '../../../BadgeWithTooltip';
import { TabLayout } from '../../TabLayout';
import { TourPageActionButtons } from '../TourPageActionButtons';
import { TourPageBreadcrumbs } from '../TourPageBreadcrumbs';
import { useTourPageProps } from '../TourPageContext';
import { TourPageTitle } from '../TourPageTitle';
import { ActivityOverview } from './ActivityOverview';
import { TourDetailsCard } from './DetailsCard';

export const OverviewTab = () => {
  const { readOnly } = useTourPageProps();
  return (
    <TabLayout
      entity="tour"
      title={<TourPageTitle />}
      breadcrumbs={<TourPageBreadcrumbs />}
      actionButtons={<TourPageActionButtons />}
      secondaryActionButtons={
        readOnly ? (
          <div className="flex items-center gap-1">
            <BadgeWithTooltip
              tooltipText="This asset is shared from another workspace. You can view and present it."
              badgeProps={{
                label: 'Read only',
                variant: 'primary',
              }}
            />
          </div>
        ) : null
      }
    >
      <div className="pb-10 w-full h-full">
        <div className="flex gap-6">
          <div className="flex-1 ">
            <TourDetailsCard />
          </div>
          <div className="flex-1">
            <ActivityOverview />
          </div>
        </div>
      </div>
    </TabLayout>
  );
};
